import { publicHttpClient } from './http-client'

export type MeetLinkTarget = {
  url: string
}

export const MeetLinksService = {
  async resolveMeetLink(code: string): Promise<MeetLinkTarget> {
    return publicHttpClient<MeetLinkTarget>(`${import.meta.env.VITE_API_URL}/meet/${encodeURIComponent(code)}`, 'get')
  },
}
